import { render, staticRenderFns } from "./PreOrderList.vue?vue&type=template&id=2f80f966&scoped=true"
import script from "./PreOrderList.vue?vue&type=script&lang=js"
export * from "./PreOrderList.vue?vue&type=script&lang=js"
import style0 from "./PreOrderList.vue?vue&type=style&index=0&id=2f80f966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f80f966",
  null
  
)

export default component.exports